import Swiper from 'swiper';

// ページの読み込み後に実行する。
// 以前は jQuery の $(function () {...}) だったが、公開サイトでは jQuery を読み込んでおらず
// （laravel-mix の autoload が自動で入れていた）、Vite への移行後に "$ is not defined" で
// スライダーが動かなくなっていたため、jQuery を使わない形にする。
function onReady(callback) {
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', callback);
	} else {
		callback();
	}
}

onReady(function () {
	//スライダー
	var mainSlider = new Swiper('.slider', {
		loop: true
	});

	//サムネイル
	var Thumbnail = new Swiper('.thumbnail', {
		breakpoints: {
			//SP用
			300: {
				slidesPerView: 4,
				spaceBetween: 5
			},
			//PC用
			500: {
				slidesPerView: 6
			}
		},
		loop: true,
		slideToClickedSlide: true,
	});

	// スライド遷移時にイベントが発生する slideChange というAPIを使用
	// スライダーをスライドした時にサムネイルを移動させる
	mainSlider.on('slideChange', () => {
		// realIndex は現在activeになっているスライドの番号が入っている
		Thumbnail.slideToLoop(mainSlider.realIndex);
	});
	// サムネイルをスライドした時にメインスライドを連動させる(上記と逆)
	Thumbnail.on('slideChange', () => {
		mainSlider.slideToLoop(Thumbnail.realIndex);
	});
});
